/* =================================================================
   LOOF SHOPIFY THEME — animations + AJAX cart
   ================================================================= */
(function(){
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const isTouch = matchMedia('(hover: none)').matches;
const $ = (s,c=document)=>c.querySelector(s);
const $$ = (s,c=document)=>[...c.querySelectorAll(s)];
const money = c => (c/100).toFixed(2).replace('.',',')+' €';

/* ---------- Preloader ---------- */
addEventListener('load',()=>{const pl=$('#preloader');if(pl)setTimeout(()=>pl.classList.add('done'),reduce?100:1300);});

/* ---------- Scroll progress + header ---------- */
const sbar=$('#scrollBar'),header=$('#header');
function onScroll(){
  if(header)header.classList.toggle('scrolled',scrollY>30);
  if(sbar){const h=document.documentElement.scrollHeight-innerHeight;sbar.style.width=(h>0?scrollY/h*100:0)+'%';}
  requestPx();stickyBuy();ritualActive();
}
addEventListener('scroll',onScroll,{passive:true});

/* ---------- Reveal ---------- */
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.12,rootMargin:'0px 0px -60px 0px'});
$$('.reveal').forEach(el=>io.observe(el));

/* ---------- Parallax ---------- */
const pxEls=$$('[data-parallax]').map(el=>({el,speed:parseFloat(el.dataset.parallax)}));
let mx=0,my=0,ticking=false;
function applyPx(){const vh=innerHeight;pxEls.forEach(({el,speed})=>{const r=el.getBoundingClientRect();const off=(r.top+r.height/2-vh/2)*speed*-0.5;el.style.transform=`translate3d(${mx*speed*22}px,${off+my*speed*16}px,0)`;});ticking=false;}
function requestPx(){if(!ticking&&!reduce){ticking=true;requestAnimationFrame(applyPx);}}
if(!isTouch)addEventListener('mousemove',e=>{mx=(e.clientX/innerWidth-.5)*2;my=(e.clientY/innerHeight-.5)*2;requestPx();});
addEventListener('scroll',requestPx,{passive:true});
addEventListener('resize',requestPx,{passive:true});
applyPx();

/* ---------- Glow cursor ---------- */
const glow=$('#glowCursor'),dot=$('#cursorDot');
if(!isTouch&&!reduce&&glow){let gx=0,gy=0,cx=0,cy=0;addEventListener('mousemove',e=>{gx=e.clientX;gy=e.clientY;glow.style.opacity=1;if(dot){dot.style.opacity=1;dot.style.left=gx+'px';dot.style.top=gy+'px';}});(function loop(){cx+=(gx-cx)*.12;cy+=(gy-cy)*.12;glow.style.left=cx+'px';glow.style.top=cy+'px';requestAnimationFrame(loop);})();$$('a,button,.pcard,.bb-soap,.opt').forEach(el=>{el.addEventListener('mouseenter',()=>dot&&dot.classList.add('big'));el.addEventListener('mouseleave',()=>dot&&dot.classList.remove('big'));});}

/* ---------- Magnetic ---------- */
if(!isTouch&&!reduce)$$('.magnetic').forEach(b=>{b.addEventListener('mousemove',e=>{const r=b.getBoundingClientRect();b.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.25}px,${(e.clientY-r.top-r.height/2)*.35}px)`;});b.addEventListener('mouseleave',()=>b.style.transform='');});

/* ---------- Product tilt ---------- */
if(!isTouch&&!reduce)$$('.pcard').forEach(c=>{c.addEventListener('mousemove',e=>{const r=c.getBoundingClientRect();const px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;c.style.transform=`perspective(900px) rotateY(${px*8}deg) rotateX(${-py*8}deg) translateY(-6px)`;});c.addEventListener('mouseleave',()=>c.style.transform='');});

/* ---------- FAQ ---------- */
$$('.faq-item').forEach(item=>{const q=item.querySelector('.faq-q');q&&q.addEventListener('click',()=>{const open=item.classList.contains('open');$$('.faq-item').forEach(i=>{i.classList.remove('open');const a=i.querySelector('.faq-a');if(a)a.style.maxHeight=null;});if(!open){item.classList.add('open');const a=item.querySelector('.faq-a');if(a)a.style.maxHeight=a.scrollHeight+'px';}});});

/* ---------- Bubbles ---------- */
const bubbles=$('#bubbles');
if(bubbles&&!reduce)for(let i=0;i<14;i++){const s=document.createElement('span');const sz=8+Math.random()*34;s.style.cssText=`width:${sz}px;height:${sz}px;left:${Math.random()*100}%;animation-delay:${Math.random()*7}s;animation-duration:${5+Math.random()*4}s`;bubbles.appendChild(s);}

/* ---------- Hero canvas ---------- */
const cv=$('#heroCanvas');
if(cv&&!reduce){const ctx=cv.getContext('2d');let parts=[],raf,vis=true;function size(){cv.width=cv.offsetWidth;cv.height=cv.offsetHeight;}function init(){size();const n=Math.min(60,Math.round(cv.width/26));parts=[];for(let i=0;i<n;i++)parts.push({x:Math.random()*cv.width,y:Math.random()*cv.height,r:Math.random()*2.6+.6,vx:(Math.random()-.5)*.25,vy:-Math.random()*.4-.1,a:Math.random()*.5+.2});}function draw(){ctx.clearRect(0,0,cv.width,cv.height);parts.forEach(p=>{p.x+=p.vx;p.y+=p.vy;if(p.y<-10){p.y=cv.height+10;p.x=Math.random()*cv.width;}if(p.x<-10)p.x=cv.width+10;if(p.x>cv.width+10)p.x=-10;const g=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*4);g.addColorStop(0,`rgba(255,200,90,${p.a})`);g.addColorStop(1,'rgba(255,200,90,0)');ctx.fillStyle=g;ctx.beginPath();ctx.arc(p.x,p.y,p.r*4,0,7);ctx.fill();});if(vis)raf=requestAnimationFrame(draw);}init();draw();addEventListener('resize',init);new IntersectionObserver(es=>{vis=es[0].isIntersecting;if(vis)draw();else cancelAnimationFrame(raf);}).observe(cv);}

/* ---------- Counters ---------- */
$$('[data-count]').forEach(el=>{const obs=new IntersectionObserver(es=>{if(es[0].isIntersecting){const target=parseFloat(el.dataset.count),suf=el.dataset.suffix||'',dur=1400,t0=performance.now();function tick(t){const p=Math.min((t-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=Math.round(target*e).toLocaleString('fr-FR')+suf;if(p<1)requestAnimationFrame(tick);}requestAnimationFrame(tick);obs.disconnect();}},{threshold:.5});obs.observe(el);});

/* ---------- Ritual sticky ---------- */
const rsteps=$$('.rstep'),rnum=$('#ritualNum');
function ritualActive(){if(!rsteps.length)return;let active=0;rsteps.forEach((s,i)=>{if(s.getBoundingClientRect().top<innerHeight*0.55)active=i;});rsteps.forEach((s,i)=>s.classList.toggle('active',i===active));if(rnum)rnum.textContent='0'+(active+1);}

/* ---------- Before/After ---------- */
const ba=$('#ba');
if(ba){const before=ba.querySelector('.ba-before'),handle=ba.querySelector('.ba-handle');let down=false;function set(x){const r=ba.getBoundingClientRect();let p=Math.max(0,Math.min(1,(x-r.left)/r.width));before.style.clipPath=`inset(0 ${100-p*100}% 0 0)`;handle.style.left=p*100+'%';}set(ba.getBoundingClientRect().left+ba.offsetWidth*0.5);const move=e=>{if(down)set(e.touches?e.touches[0].clientX:e.clientX);};ba.addEventListener('mousedown',e=>{down=true;set(e.clientX);});ba.addEventListener('touchstart',e=>{down=true;set(e.touches[0].clientX);},{passive:true});addEventListener('mouseup',()=>down=false);addEventListener('touchend',()=>down=false);addEventListener('mousemove',move);addEventListener('touchmove',move,{passive:true});}

/* ---------- PDP gallery / stepper / options ---------- */
$$('.pdp-thumb').forEach(th=>th.addEventListener('click',()=>{$$('.pdp-thumb').forEach(t=>t.classList.remove('active'));th.classList.add('active');const main=$('#pdpMain .pdp-media-img, #pdpMain img, #pdpMain .soap');if(main&&th.dataset.img){if(main.tagName==='IMG')main.src=th.dataset.img;}if(main&&th.dataset.grad&&main.classList.contains('soap'))main.style.background=th.dataset.grad;}));
let qty=1;const stepEl=$('#qtyVal');
const pdpPriceEl=$('#pdpPrice'),pdpWasEl=$('#pdpWas');
let pdpUnit=pdpPriceEl?Number(pdpPriceEl.dataset.unit||0):0;
let pdpCompare=pdpWasEl?Number(pdpWasEl.dataset.compare||0):0;
function updatePdpPrice(){
  if(pdpPriceEl&&pdpUnit)pdpPriceEl.textContent=money(pdpUnit*qty);
  if(pdpWasEl&&pdpCompare)pdpWasEl.textContent=money(pdpCompare*qty);
}
$('#qtyMinus')&&$('#qtyMinus').addEventListener('click',()=>{qty=Math.max(1,qty-1);stepEl.textContent=qty;updatePdpPrice();});
$('#qtyPlus')&&$('#qtyPlus').addEventListener('click',()=>{qty++;stepEl.textContent=qty;updatePdpPrice();});
$$('.opt-row').forEach(row=>row.addEventListener('click',e=>{const o=e.target.closest('.opt');if(!o)return;row.querySelectorAll('.opt').forEach(x=>x.classList.remove('sel'));o.classList.add('sel');const vid=o.dataset.variantId;if(vid){const pa=$('#pdpAdd');if(pa)pa.dataset.variantId=vid;const sb=$('#sbAdd');if(sb)sb.dataset.variantId=vid;}if(o.dataset.price){pdpUnit=Number(o.dataset.price);pdpCompare=Number(o.dataset.compare||0);updatePdpPrice();}}));

/* ---------- Sticky buy bar ---------- */
const sb=$('#stickyBuy'),buyAnchor=$('#pdpBuyAnchor');
function stickyBuy(){if(!sb||!buyAnchor)return;const f=$('.footer');const atFoot=f?f.getBoundingClientRect().top<innerHeight:false;sb.classList.toggle('show',buyAnchor.getBoundingClientRect().bottom<0&&!atFoot);}

/* ---------- Burger ---------- */
$('#burger')&&$('#burger').addEventListener('click',()=>{const t=$('#produits')||$('.pdp');t&&t.scrollIntoView({behavior:'smooth'});});

/* =================================================================
   SHOPIFY AJAX CART
   ================================================================= */
const drawer=$('#drawer'),overlay=$('#overlay'),cartBtn=$('#cartBtn');
function openCart(){overlay&&overlay.classList.add('show');drawer&&drawer.classList.add('show');}
function closeCart(){overlay&&overlay.classList.remove('show');drawer&&drawer.classList.remove('show');}
cartBtn&&cartBtn.addEventListener('click',e=>{e.preventDefault();fetchCart();openCart();});
$('#drawerClose')&&$('#drawerClose').addEventListener('click',closeCart);
overlay&&overlay.addEventListener('click',closeCart);
addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();});

function fly(src){
  if(reduce||!src||!cartBtn)return;
  const s=src.getBoundingClientRect(),t=cartBtn.getBoundingClientRect();
  const grad=src.dataset.flycolor||'linear-gradient(160deg,#FFD98A,#FF8A00)';
  const d=document.createElement('div');d.className='fly';d.style.background=grad;
  d.style.left=s.left+s.width/2-11+'px';d.style.top=s.top+s.height/2-11+'px';document.body.appendChild(d);
  const dx=t.left+t.width/2-(s.left+s.width/2),dy=t.top+t.height/2-(s.top+s.height/2);
  d.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${dx*.5}px,${dy*.5-80}px) scale(1.2)`,opacity:1,offset:.6},{transform:`translate(${dx}px,${dy}px) scale(.2)`,opacity:.4}],{duration:750,easing:'cubic-bezier(.5,0,.6,1)'}).onfinish=()=>d.remove();
}

async function addToCart(items,src){
  try{
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
    if(!res.ok)throw new Error('add failed');
    fly(src);await fetchCart();setTimeout(openCart,380);
  }catch(err){console.error(err);location.href='/cart';}
}
async function changeLine(key,quantity){
  try{const res=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});const cart=await res.json();renderCart(cart);}catch(e){console.error(e);}
}
async function fetchCart(){try{const res=await fetch('/cart.js');renderCart(await res.json());}catch(e){console.error(e);}}

function renderCart(cart){
  const count=$('#cartCount'),items=$('#cartItems'),empty=$('#cartEmpty'),foot=$('#drawerFoot');
  if(count){count.textContent=cart.item_count;count.classList.toggle('show',cart.item_count>0);}
  if(!items)return;
  items.querySelectorAll('.citem').forEach(e=>e.remove());
  if(!cart.items.length){empty&&(empty.style.display='block');foot&&(foot.style.display='none');return;}
  empty&&(empty.style.display='none');foot&&(foot.style.display='block');
  let savings=0;
  cart.items.forEach(it=>{
    if(it.original_line_price>it.final_line_price)savings+=it.original_line_price-it.final_line_price;
    const row=document.createElement('div');row.className='citem';
    const img=it.image?`<img class="cimg" src="${it.image}" alt="" style="object-fit:cover">`:`<div class="soap cimg" style="background:linear-gradient(160deg,#FBE7C4,#E0A964)"></div>`;
    const was=it.original_price>it.final_price?`<span style="text-decoration:line-through;color:var(--ink-faint);font-size:.78rem">${money(it.original_price)}</span>`:'';
    row.innerHTML=`${img}<div class="cinfo"><h4>${it.product_title}</h4>
      <div class="cprice">${money(it.final_price)} ${was}</div>
      <div class="qty"><button data-key="${it.key}" data-q="${it.quantity-1}">−</button><span>${it.quantity}</span><button data-key="${it.key}" data-q="${it.quantity+1}">+</button></div>
      <div class="crem" data-key="${it.key}" data-q="0">Retirer</div></div>`;
    items.appendChild(row);
  });
  const sub=$('#subtotal'),sav=$('#savings'),tot=$('#total');
  if(sub)sub.textContent=money(cart.items_subtotal_price+savings);
  if(sav)sav.textContent='-'+money(savings);
  if(tot)tot.textContent=money(cart.total_price);
  updateShipBar(cart.total_price);
}

/* Barre de livraison offerte dynamique */
function updateShipBar(total){
  const bar=$('#shipBar'); if(!bar)return;
  const thr=parseInt(bar.dataset.threshold,10)||0;
  const fill=$('#shipFill'), msg=$('#shipMsg');
  if(thr<=0){ bar.style.display='none'; return; }
  bar.style.display='';
  const pct=Math.max(0,Math.min(100,Math.round(total/thr*100)));
  if(fill)fill.style.width=pct+'%';
  if(msg){
    if(total>=thr){ msg.textContent=bar.dataset.msgReached||'Livraison offerte débloquée !'; bar.classList.add('reached'); }
    else { const remaining=money(thr-total); msg.textContent=(bar.dataset.msg||'Plus que {remaining} pour la livraison offerte !').replace('{remaining}',remaining); bar.classList.remove('reached'); }
  }
}
$('#cartItems')&&$('#cartItems').addEventListener('click',e=>{const t=e.target.closest('[data-key]');if(!t)return;changeLine(t.dataset.key,parseInt(t.dataset.q,10));});

/* Wire add buttons (data-variant-id, optional data-items for bundles) */
$$('[data-add]').forEach(btn=>{
  btn.addEventListener('click',e=>{
    e.preventDefault();e.stopPropagation();
    const raw=btn.dataset.items;
    if(raw){try{addToCart(JSON.parse(raw),btn);}catch(_){}return;}
    const id=btn.dataset.variantId;if(!id)return;
    const q=btn.hasAttribute('data-use-qty')? qty : 1;
    addToCart([{id:Number(id),quantity:q}],btn);
  });
});

/* Favoris (localStorage) */
(function(){
  var KEY='loof_favs';
  function get(){try{return JSON.parse(localStorage.getItem(KEY))||[];}catch(_){return[];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(_){}}
  $$('.wish[data-wish]').forEach(function(w){
    var id=w.getAttribute('data-wish');
    if(get().indexOf(id)>-1) w.classList.add('active');
    w.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();
      var f=get(),i=f.indexOf(id);
      if(i>-1){f.splice(i,1);w.classList.remove('active');}else{f.push(id);w.classList.add('active');}
      save(f);
    });
  });
})();

/* Bundle builder (Shopify) */
const bundle=$('#bundle');
if(bundle){
  const sel=new Set();const addB=$('#bbAdd');
  const cntEl=$('#bbCount'),bigEl=$('#bbPrice'),wasEl=$('#bbWas'),discEl=$('#bbDisc');
  const UNIT=1592,WAS=1990; // cents, fallback display only
  function price(){const n=sel.size;let unit=UNIT,label='';if(n>=4){unit=1325;label='Pack complet -33%';}else if(n===3){unit=1433;label='Trio -10%';}else if(n===2){unit=1513;label='Duo -5%';}
    if(cntEl)cntEl.textContent=n+(n>1?' savons sélectionnés':' savon sélectionné');
    if(bigEl)bigEl.textContent=n?money(unit*n):'—';
    if(wasEl){wasEl.textContent=n?money(WAS*n):'';wasEl.style.display=n>1?'block':'none';}
    if(discEl){discEl.style.display=label?'inline-flex':'none';discEl.textContent=label;}
    if(addB){addB.disabled=n===0;addB.textContent=n?'Ajouter au panier':'Sélectionnez vos savons';}
  }
  $$('.bb-soap').forEach(s=>s.addEventListener('click',()=>{const k=s.dataset.variantId;if(!k)return;if(sel.has(k)){sel.delete(k);s.classList.remove('sel');}else{sel.add(k);s.classList.add('sel');}price();}));
  addB&&addB.addEventListener('click',async function(){
    var ids=[...sel]; if(!ids.length)return;
    var orig=addB.textContent; addB.disabled=true; addB.textContent='Ajout en cours…';
    var added=0;
    for(var j=0;j<ids.length;j++){
      try{
        var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(ids[j]),quantity:1}]})});
        if(r.ok)added++;
      }catch(e){}
    }
    await fetchCart(); addB.disabled=false; addB.textContent=orig;
    if(added){ fly(bundle.querySelector('.bb-soap.sel')); setTimeout(openCart,300); }
    else { location.href='/cart'; }
  });
  price();
}

fetchCart();
onScroll();
})();

/* =====================================================================
   v2 — SCRUB TO LATHER (frotter pour exfolier) — theme
   ===================================================================== */
(function(){
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$=(s,c=document)=>[...c.querySelectorAll(s)];
  $$('[data-scrub]').forEach(setupScrub);
  function setupScrub(img){
    const host=img.closest('.pstage,.pdp-main,.hero-soap-wrap')||img.parentElement;
    if(!host||host.dataset.scrubReady) return;
    host.dataset.scrubReady='1'; host.classList.add('scrub-host');
    const cap=document.createElement('div'); cap.className='foam-cap'; host.appendChild(cap);
    const done=document.createElement('div'); done.className='scrub-done'; done.textContent='✨ Tout doux'; host.appendChild(done);
    let progress=0,last=0,lastX=0,lastY=0,burst=false,raf=null;
    function bubble(x,y,big){const b=document.createElement('span');b.className='bub';const sz=(big?9:5)+Math.random()*(big?15:9);b.style.width=b.style.height=sz+'px';b.style.left=x+'px';b.style.top=y+'px';b.style.setProperty('--dx',(Math.random()*46-23)+'px');b.style.setProperty('--d',(0.85+Math.random()*0.95)+'s');host.appendChild(b);b.addEventListener('animationend',()=>b.remove());}
    function paint(){const p=Math.min(progress,1);cap.style.opacity=p*0.9;cap.style.transform=`translateX(-50%) scaleY(${0.5+p*0.6})`;}
    function decay(){progress=Math.max(0,progress-0.012);paint();if(progress<=0){cancelAnimationFrame(raf);raf=null;burst=false;img.classList.remove('lathered');return;}raf=requestAnimationFrame(decay);}
    function onMove(e){const r=host.getBoundingClientRect();const x=e.clientX-r.left,y=e.clientY-r.top;if(x<0||y<0||x>r.width||y>r.height)return;const dist=Math.hypot(x-lastX,y-lastY);lastX=x;lastY=y;const now=performance.now();const pressing=(e.pressure>0)||(e.buttons>0)||e.pointerType==='touch';progress=Math.min(progress+(pressing?0.05:0.022)+Math.min(dist,40)/950,1.4);img.classList.add('lathered');paint();if(now-last>(pressing?26:52)){last=now;bubble(x,y,pressing);if(pressing&&Math.random()>.5)bubble(x+(Math.random()*20-10),y+(Math.random()*10-5),false);}if(progress>=1&&!burst){burst=true;for(let i=0;i<16;i++)bubble(r.width*(0.28+Math.random()*0.44),r.height*(0.26+Math.random()*0.4),true);done.classList.add('show');setTimeout(()=>done.classList.remove('show'),1150);}if(!raf)raf=requestAnimationFrame(decay);}
    host.addEventListener('pointermove',onMove,{passive:true});
    host.addEventListener('pointerdown',e=>{try{host.setPointerCapture(e.pointerId);}catch(_){}onMove(e);});
    host.addEventListener('pointerup',e=>{try{host.releasePointerCapture(e.pointerId);}catch(_){}});
  }
})();

/* loof-smoothscroll — same-page anchors scroll smoothly; cross-page hash scrolls on load */
(function(){
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('a[href]'); if(!a) return;
    var u; try{u=new URL(a.href, location.href);}catch(_){return;}
    if(u.pathname===location.pathname && u.hash && u.hash.length>1){
      var el=document.querySelector(u.hash);
      if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'start'}); history.replaceState(null,'',u.hash); }
    }
  });
  window.addEventListener('load',function(){
    if(location.hash && location.hash.length>1){ var el=document.querySelector(location.hash); if(el) setTimeout(function(){el.scrollIntoView({behavior:'smooth',block:'start'});},350); }
  });
})();

/* =================================================================
   BILAN PEAU — quiz interactif (section skin-quiz)
   ================================================================= */
(function(){
  var quizzes = document.querySelectorAll('.sq[data-sq]');
  if(!quizzes.length) return;
  quizzes.forEach(function(root){
    if(root.dataset.wired) return; root.dataset.wired = '1';
    var steps = Array.prototype.slice.call(root.querySelectorAll('.sq-step'));
    var fill = root.querySelector('[data-sq-fill]');
    var stepsWrap = root.querySelector('.sq-steps');
    var results = root.querySelector('[data-sq-results]');
    var votes = {}, cur = 0, total = steps.length;

    function show(i){
      steps.forEach(function(s,k){ s.classList.toggle('is-active', k === i); });
      if(fill) fill.style.width = Math.round((i + 1) / total * 100) + '%';
    }
    function finish(){
      var best = null, bestN = 0, tie = false;
      Object.keys(votes).forEach(function(k){
        if(!k) return;
        if(votes[k] > bestN){ best = k; bestN = votes[k]; tie = false; }
        else if(votes[k] === bestN){ tie = true; }
      });
      if(votes.pack) best = 'pack';
      if(!best || (tie && bestN <= 1)) best = 'pack';
      if(stepsWrap) stepsWrap.hidden = true;
      if(results) results.hidden = false;
      if(fill) fill.style.width = '100%';
      var cards = results ? results.querySelectorAll('.sq-result') : [], matched = false;
      cards.forEach(function(c){
        var on = c.dataset.result === best;
        c.classList.toggle('show', on);
        c.hidden = !on;
        if(on) matched = true;
      });
      if(!matched && cards[0]){ cards[0].classList.add('show'); cards[0].hidden = false; }
      if(results) results.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    root.querySelectorAll('.sq-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        var s = btn.dataset.soap;
        if(s){ votes[s] = (votes[s] || 0) + 1; }
        cur++;
        if(cur < total){ show(cur); } else { finish(); }
      });
    });
    var restart = root.querySelector('[data-sq-restart]');
    if(restart) restart.addEventListener('click', function(){
      votes = {}; cur = 0;
      if(results) results.hidden = true;
      if(stepsWrap) stepsWrap.hidden = false;
      if(results) results.querySelectorAll('.sq-result').forEach(function(c){ c.classList.remove('show'); c.hidden = true; });
      show(0);
    });
    show(0);
  });
})();
